<template>
  <div class="Button" :class="buttonClasses">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Button',

  props: {
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonClasses () {
      const classes = []

      if (this.small) {
        classes.push('Button--isSmall')
      }

      return classes
    }
  }
}
</script>

<style>
.Button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 173px;
  height: 52px;
  background-color: var(--color-1);
  border-radius: 24px;
  border: 3px solid var(--color-2);
  font-size: 22px;
  line-height: 1;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}

.Button:active {
  background-color: var(--color-3);
  border-color: var(--color-3);
  color: var(--color-1);
}

.Button--isSmall {
  padding-top: 2px;
  height: 42px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// Button.vue?58419e18